import { IScheduledDeliveryRepository, ScheduledDeliveriesQuery } from '../../ports/IScheduledDeliveryRepository'
import { ScheduledDeliveryEntity } from '../../../domain/entities/ScheduledDelivery'

export class ListScheduledDeliveriesUseCase {
  constructor(private repo: IScheduledDeliveryRepository) {}
  async execute(params: ScheduledDeliveriesQuery): Promise<ScheduledDeliveryEntity[]> {
    return this.repo.list(params)
  }
}
